
export class TipoActivoFijo{
    public constructor(
        public id: String = "",
        public nombre:String = "",
        public vida_util:String = "",
        public tasa_depreciacion_anual:string = "",
        public empresa_id:String = "",
        public usuario_id:String = null,
        public status: String = "",

    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo-activo-fijo.ts